<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "square-spin" [fullScreen] = "true"><p style="color: white" ></p></ngx-spinner>


<ngx-ui-loader fgsColor="#edebff" fgsType="square-loader" bgsColor="#006eff" bgsType="ball-spin-clockwise-fade-rotating"
></ngx-ui-loader>

